// TransformWrapper.tsx

import React from "react";
import { useAppSelector } from "../../../store/store";
import { getFrameSize } from "@builder/store/slices/BuilderSlice/builderSelectors";

interface TransformWrapperProps {
    children: React.ReactNode;
    scrollAreaWidth: number;
    scrollAreaHeight: number;
    onBuildRef?: (ref: HTMLDivElement | null) => void;
}

const TransformWrapper: React.FC<TransformWrapperProps> = ({ children, scrollAreaWidth, scrollAreaHeight, onBuildRef }) => {
    const frameSize = useAppSelector(getFrameSize);
    const transform = useAppSelector(state => state.frameTransform);

    return (
        <div
            className="oliver-build-scroll-content"
            style={{
                width: scrollAreaWidth + "px",
                height: scrollAreaHeight + "px",
                position: "relative"
            }}
        >
            <div
                ref={onBuildRef}
                className="oliver-build"
                style={{
                    width: frameSize.x + "px",
                    height: frameSize.y === "fit-content" ? "auto" : frameSize.y + "px",
                    transform: `translate(-50%, -50%) scale(${transform.scale.value})`,
                    position: "absolute",
                    left: scrollAreaWidth / 2 + "px",
                    top: scrollAreaHeight / 2 + "px",
                    transformOrigin: "center center"
                }}
            >
                {children}
            </div>
        </div>
    );
};

export default TransformWrapper;
